import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { InstanceComponent } from './instance.component';
import { InstanceViewComponent } from './components';
import { ValidateParamsGuard } from '../../shared/guards';
import { TasksComponent } from './components/tasks/tasks.component';
import { SchedulerPageComponent } from './components/scheduler-page/scheduler-page.component';
import { ProcessDetailsViewTabComponent } from './components/process-detail-view-tab/process-details-view-tab.component';
import { ZoningCodeViewComponent } from './components/zoning-code-view/zoning-code-view.component';

const routes: Routes = [
    {
        path: '',
        component: InstanceComponent,
        children: [
            {
                path: 'tasks',
                children: [
                    {
                        path: '',
                        component: TasksComponent,
                        canActivate: [ValidateParamsGuard]
                    }
                ]
            },
            {
                path: 'task',
                children: [
                    {
                        path: ':id',
                        component: ProcessDetailsViewTabComponent
                    }
                ]
            },
            {
                path: 'instance/:id',
                component: InstanceViewComponent,
                canActivate: [ValidateParamsGuard],
                data: {
                    parametersSchema: {
                        params: { id: '^\\d+$' },
                        failRedirectURL: '/instances'
                    }
                }
            },
            {
                path: 'jobs',
                component: SchedulerPageComponent,
                canActivate: [ValidateParamsGuard]
            },
            {
                path: 'zoning-code/:id',
                component: ZoningCodeViewComponent,
                canActivate: [ValidateParamsGuard],
                data: {
                    parametersSchema: {
                        params: { id: '^\\d+$' },
                        failRedirectURL: '/instances'
                    }
                }
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class InstanceRoutingModule {}
